import { render, staticRenderFns } from "./vb-dropdown-search.vue?vue&type=template&id=30fa6c30&scoped=true"
import script from "./vb-dropdown-search.vue?vue&type=script&lang=js"
export * from "./vb-dropdown-search.vue?vue&type=script&lang=js"
import style0 from "./vb-dropdown-search.vue?vue&type=style&index=0&id=30fa6c30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fa6c30",
  null
  
)

export default component.exports